import * as React from 'react';
import Button from '@mui/material/Button';
import { Breakpoint, styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

export interface DialogTitleProps {
  id: string;
  children?: React.ReactNode;
  onClose: () => void;
}

const BootstrapDialogTitle = (props: DialogTitleProps) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

interface DialogProps {
    isTermsOpen: boolean
    setIsTermsOpen: (valor: boolean) => void
    setCheckTerms?: (valor: boolean) => void
    children: React.ReactNode
    title: string
    width?: Breakpoint | false | undefined
}


export default function CustomizedDialogs({ isTermsOpen, setIsTermsOpen, setCheckTerms, children, title, width = 'xl' }: DialogProps) {

  const handleClose = () => {
    setIsTermsOpen(false);
  };

  const handleAgreeOrClose = () => {
    setIsTermsOpen(false)
    setCheckTerms && setCheckTerms(true)
  }

  return (
    <div>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        maxWidth={width}
        fullWidth
        open={isTermsOpen}
        >
        <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose}>
          {title}
        </BootstrapDialogTitle>
        <DialogContent dividers sx={{minHeight: '70vh'}}>
          {children}
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleAgreeOrClose}>
            {setCheckTerms ? 'Concordar' : 'Fechar'}
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </div>
  );
}
